import React from 'react';

const Analysis = () => (
  <svg
    width="31px"
    height="32px"
    viewBox="0 0 31 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Current-Designs"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Artboard-Copy-2" strokeWidth="1.44">
        <g id="Premium-analysis" transform="translate(0.000000, 0.000000)">
          <g id="Group-26-Copy-2" transform="translate(10.746627, 0.000000)">
            <path
              d="M5.87304057,20.7553835 C6.035425,20.7672705 6.19886077,20.7732534 6.36313422,20.7732534 C8.16972348,20.7732534 9.86137884,20.0456103 11.1118802,18.7720951 L11.2894274,18.5912804 L11.5410854,18.5615285 C16.0193505,18.0320909 19.429925,14.2204274 19.429925,9.67196402 C19.429925,4.72793081 15.4219942,0.72 10.477961,0.72 L9.67196402,0.72 C4.72793081,0.72 0.72,4.72793081 0.72,9.67196402 C0.72,13.4934156 3.13662082,16.8558344 6.68016842,18.1119888 L7.48980101,18.3989959 L7.06576094,19.1460354 C6.73380133,19.730855 6.33264006,20.2712124 5.87304057,20.7553835 Z"
              id="Combined-Shape-Copy-5"
              stroke="#FFFFFF"
            />
            <path
              d="M4.02998501,11.0587057 C5.72648786,7.26940649 10.4778947,4.72921426 13.4332834,8.77295383 C9.78591382,8.77295383 9.78591382,12.5937031 13.4332834,13.4332834"
              id="Path-3-Copy-10"
              stroke="#22D737"
            />
          </g>
          <g
            id="Group-29-Copy"
            transform="translate(0.000000, 16.119940)"
            stroke="#FFFFFF"
          >
            <g id="Group-27-Copy">
              <path
                d="M0,14.7766117 C0,12.3586207 3.87006497,10.7466267 7.38830585,10.7466267 C10.9065467,10.7466267 14.7766117,12.3586207 14.7766117,14.7766117"
                id="Path-5-Copy-3"
                strokeLinecap="round"
              />
              <circle
                id="Oval-4-Copy-3"
                cx="7.38830585"
                cy="3.35832084"
                r="3.35832084"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Analysis;
